import { sendRequestAuth } from 'api/api'
import { removeAcent } from 'common/fieldText/_functions'
import { convertDateTimeToApiFormat } from 'common/form/datePicker/_functions'
import config from 'config'
import { useCallback, useContext } from 'react'
import { DateRangePicker } from 'rsuite'
import {
  INVOICE_FILTER_TAG_FIELDS,
} from '../interfaces/_constants'
import { InvoiceContext } from '../provider/_context'
import { invoiceActions } from '../provider/_reducer'
import { debounce } from '@mui/material'
import { invoiceInitialState } from 'Pages/invoice/provider/_initState'
import { useSearchParams } from 'react-router-dom'
import { generatePaymentPeriods } from '../utils/transform'

const useInvoiceFilterForm = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const { pageState, pageDispatch } = useContext(InvoiceContext)
  const { filter, table } = pageState

  // ===== ===== ===== ===== =====
  // SEARCH
  // ===== ===== ===== ===== =====
  const searchValue = filter.search.value
  const querySearch = searchParams.get('search') || ''

  // ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== =====
  // ===== ===== ===== ===== =====
  // DATE TIME
  // ===== ===== ===== ===== =====
  const { afterToday } = DateRangePicker
  const dateTimeActiveValue = filter.dateTime.activeValue
  const dateTimeEnd = filter.dateTime.end
  const dateTimeStart = filter.dateTime.start
  const dateTimeDefaultValue = [dateTimeStart,dateTimeEnd]
  const dateTimeType = filter.dateTime.type
  const dateTimeValue = filter.dateTime.value
  const dateTimeTrigger = filter.dateTime.trigger

  const handleDateTimeChange = data =>
    pageDispatch({
      type: invoiceActions.FILTER_DATE_TIME_UPDATE,
      payload: {
        end: data.value[1],
        start: data.value[0],
        type: data.category,
        value: data.formatValue,
      },
    })


  // ===== ===== ===== ===== =====
  // principal
  // ===== ===== ===== ===== =====
  const principalActiveValue = filter.principal.activeValue
  const principalKeyword = filter.principal.keyword
  const principalList = filter.principal.list
  const principalListOrigin = filter.principal.listOrigin
  const principalValue = filter.principal.value

  const handlePrincipalChange = async (data) => {
    pageDispatch({
      type: invoiceActions.FILTER_PRINCIPAL_UPDATE,
      payload: { value: data },
    })
    // get list teacher
    const response = await sendRequestAuth('get', `${config.API}/order/filter/teachers?principal_id=${data?.value}`)
    pageDispatch({
      type: invoiceActions.FILTER_TEACHER_LIST_UPDATE,
      payload: {
        teacher: {
          list: response.data?.map(item => ({
            name: item?.name || '',
            value: item?.id || '',
          })),
        }
      },
    })

  }

  const handlePrincipalKeywordChange = data => {
    const formatDataValue = data?.value
      ? removeAcent(data?.value?.toLowerCase())
      : ''

    const principalListData = principalListOrigin.filter(item => {
      const formatNameItem = item?.name
        ? removeAcent(item.name.toLowerCase())
        : ''
      if (formatNameItem.includes(formatDataValue)) return true
      return false
    })

    pageDispatch({
      type: invoiceActions.FILTER_PRINCIPAL_KEYWORD_UPDATE,
      payload: {
        keyword: data?.value || '',
        list: principalListData,
      },
    })
  }
// ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== =====

  // ===== ===== ===== ===== =====
  // Employee
  // ===== ===== ===== ===== =====
  const teacherActiveValue = filter.teacher.activeValue
  const teacherKeyword = filter.teacher.keyword
  const teacherList = filter.teacher.list
  const teacherListOrigin = filter.teacher.listOrigin
  const teacherValue = filter.teacher.value

  const handleEmployeeChange = data =>
    pageDispatch({
      type: invoiceActions.FILTER_TEACHER_UPDATE,
      payload: { value: data },
    })

  const handleEmployeeKeywordChange = data => {
    const formatDataValue = data?.value
      ? removeAcent(data?.value?.toLowerCase())
      : ''

    const teacherListData = teacherListOrigin.filter(item => {
      const formatNameItem = item?.name
        ? removeAcent(item.name.toLowerCase())
        : ''
      if (formatNameItem.includes(formatDataValue)) return true
      return false
    })

    pageDispatch({
      type: invoiceActions.FILTER_TEACHER_KEYWORD_UPDATE,
      payload: {
        keyword: data?.value || '',
        list: teacherListData,
      },
    })
  }

  // ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== =====

  // ===== ===== ===== ===== =====
  // INVOICE INFO
  // ===== ===== ===== ===== =====
  const invoiceInfoValue = filter.invoiceInfo.value
  const invoiceInfoActiveValue = filter.invoiceInfo.activeValue

  const handleInvoiceInfoChange = value => {
    if (value === ' ') value = ''
    pageDispatch({
      type: invoiceActions.FILTER_INVOICE_INFO_UPDATE,
      payload: { value: value },
    })
  }

  // ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== =====
  // ===== ===== ===== ===== =====
  // STATUS FILTER
  // ===== ===== ===== ===== =====
  const statusValue = filter?.status?.value
  const statusActiveValue = filter?.status?.activeValue

  const handleStatusChange = value => {
    pageDispatch({
      type: invoiceActions.FILTER_STATUS_VALUE_UPDATE,
      payload: value
    })
  }

  // ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== =====
  // ===== ===== ===== ===== =====
  // INVOICE TYPE FILTER
  // ===== ===== ===== ===== =====
  const invoiceTypeValue = filter?.invoiceType?.value
  const invoiceTypeActiveValue = filter?.invoiceType?.activeValue

  const handleInvoiceTypeChange = value => {
    pageDispatch({
      type: invoiceActions.FILTER_INVOICE_TYPE_VALUE_UPDATE,
      payload: value
    })
  }

  // ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== =====
  // ===== ===== ===== ===== =====
  // INVOICE TYPE FILTER
  // ===== ===== ===== ===== =====
  const monthTimeValue = filter?.monthTime?.value
  const monthTimeActiveValue = filter?.monthTime?.activeValue

  const handleMonthTimeChange = value => {
    pageDispatch({
      type: invoiceActions.FILTER_MONTH_TIME_VALUE_UPDATE,
      payload: value
    })
  }
  // ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== =====
  const canSubmitOtherFilter = [
    dateTimeActiveValue.value !== dateTimeValue ||
    JSON.stringify(dateTimeActiveValue.type) !== JSON.stringify(dateTimeType),
    JSON.stringify(principalActiveValue) !== JSON.stringify(principalValue),
    JSON.stringify(teacherActiveValue) !== JSON.stringify(teacherValue),
    JSON.stringify(statusActiveValue) !== JSON.stringify(statusValue),
    JSON.stringify(invoiceTypeActiveValue) !== JSON.stringify(invoiceTypeValue),
    JSON.stringify(monthTimeActiveValue) !== JSON.stringify(monthTimeValue),
    JSON.stringify(invoiceInfoActiveValue) !== JSON.stringify(invoiceInfoValue),
  ].includes(true)

  const queries = {
    date_type: dateTimeActiveValue?.type?.value || '',
    start_date:
      dateTimeActiveValue?.start && dateTimeActiveValue.value
        ? convertDateTimeToApiFormat(dateTimeActiveValue.value.split(' - ')[0])
        : '',
    end_date:
      dateTimeActiveValue?.end && dateTimeActiveValue.value
        ? convertDateTimeToApiFormat(dateTimeActiveValue.value.split(' - ')[1])
        : '',
    principal_id: principalActiveValue?.value || '',
    user_id: teacherActiveValue?.value || '',
    payment_status: statusActiveValue?.value || '',
    payment_method: invoiceTypeActiveValue?.value || '',
    month_time: monthTimeActiveValue || '',
    tracking_code: invoiceInfoActiveValue || '',
    per_page: table?.pagination?.amount || 20,
    start: 0,
  }

  const debounceInvoiceByFilter = useCallback(debounce((keyword, queries) => {
    fetchInvoiceByFilter(
      { ...queries, keyword: keyword.trim() },
      { forceLoading: true },
    )
  }, 500), [queries])

  const applyInvoiceOtherFilter = async () => {
    const collection = {
      ...queries,
      date_type: dateTimeType?.value || '',
      start_date:
        dateTimeStart && dateTimeValue
          ? convertDateTimeToApiFormat(dateTimeValue.split(' - ')[0])
          : '',
      end_date:
        dateTimeEnd && dateTimeValue
          ? convertDateTimeToApiFormat(dateTimeValue.split(' - ')[1])
          : '',
      principal_id: principalValue?.value || '',
      payment_status: statusValue?.value || '',
      payment_method: invoiceTypeValue?.value || '',
      month_time: monthTimeValue || '',
      user_id: teacherValue?.value || '',
      tracking_code: invoiceInfoValue || '',
    }
    fetchInvoiceByFilter(collection, { forceLoading: true })
  }

  const fetchInvoiceByFilter = async (qs, opt) => {
    setSearchParams('')
    if (Number.isNaN(opt?.activePage) || opt?.forceLoading)
      pageDispatch({
        type: invoiceActions.TABLE_DISPLAY_LOADING_UPDATE,
        payload: { table: { display: { loading: true } } },
      })

    let queryString = '?'
    let i = 0
    for (const [key, value] of Object.entries(qs)) {
      queryString += `${i > 0 ? '&' : ''}${key}=${value}`
      i++
    }

    const response = await Promise.all([
      sendRequestAuth('get', `${config.API}/commission/tracking/trackings${queryString}`),
    ])

    if (!!response[0]?.data?.success) {
      pageDispatch({
        type: invoiceActions.OTHER_FILTER_APPLY,
        payload: {
          display: {
            list: response[0].data.data
          },
          pagination: {
            active: opt?.activePage || 0,
            amount: table.pagination.amount,
            total: response[0]?.data?.meta?.total
              ? Math.ceil(
                response[0]?.data?.meta?.total / table.pagination.amount,
              )
              : 0,
            totalItems: response[0]?.data?.meta?.total || 0,
          },
        },
      })
    }

    if (!!!opt?.notClearDetail)
      pageDispatch({
        type: invoiceActions.TABLE_DISPLAY_DETAIL_UPDATE,
        payload: { active: null },
      })

    if (Number.isNaN(opt?.activePage) || opt?.forceLoading)
      pageDispatch({
        type: invoiceActions.TABLE_DISPLAY_LOADING_UPDATE,
        payload: { table: { display: { loading: false } } },
      })

    pageDispatch({
      type: invoiceActions.TABLE_DISPLAY_DETAIL_ID_UPDATE,
      payload: { id: null },
    })
  }
  const fetchInvoiceByTagDelete = async (qs, opt) => {
    setSearchParams('')
    if (Number.isNaN(opt?.activePage) || opt?.forceLoading)
      pageDispatch({
        type: invoiceActions.TABLE_DISPLAY_LOADING_UPDATE,
        payload: { table: { display: { loading: true } } },
      })

    let queryString = '?'
    let i = 0
    for (const [key, value] of Object.entries(qs)) {
      queryString += `${i > 0 ? '&' : ''}${key}=${value}`
      i++
    }

    const response = await Promise.all([
      sendRequestAuth('get', `${config.API}/commission/tracking/trackings${queryString}`),
    ])

    if (!!response[0]?.data?.success) {
      pageDispatch({
        type: invoiceActions.DELETE_TAG_UPDATE,
        payload: {
          display: {
            list: response[0].data.data
          },
          pagination: {
            active: opt?.activePage || 0,
            amount: table.pagination.amount,
            total: response[0]?.data?.meta?.total
              ? Math.ceil(
                response[0]?.data?.meta?.total / table.pagination.amount,
              )
              : 0,
            totalItems: response[0]?.data?.meta?.total || 0,
          },
        },
      })
    }

    if (!!!opt?.notClearDetail)
      pageDispatch({
        type: invoiceActions.TABLE_DISPLAY_DETAIL_UPDATE,
        payload: { active: null },
      })

    if (Number.isNaN(opt?.activePage) || opt?.forceLoading)
      pageDispatch({
        type: invoiceActions.TABLE_DISPLAY_LOADING_UPDATE,
        payload: { table: { display: { loading: false } } },
      })

    pageDispatch({
      type: invoiceActions.TABLE_DISPLAY_DETAIL_ID_UPDATE,
      payload: { id: null },
    })
  }

  const filterTagDelete = t => {
    pageDispatch({
      type: invoiceActions.TAG_FILTER_DELETE,
      payload: { type: t, isSingle: true },
    })

    let tmpCollection = {}
    switch (t) {
      case 'dateTime.current':
        tmpCollection = {
          ...tmpCollection,
          date_type: '',
          start_date: '',
          end_date: '',
        }

        pageDispatch({
          type: invoiceActions.FILTER_DATE_TIME_TRIGGER_UPDATE,
          payload: { trigger: null },
        })

        break

      case INVOICE_FILTER_TAG_FIELDS[1]:
        tmpCollection = {
          ...tmpCollection,
        }
        break

      case INVOICE_FILTER_TAG_FIELDS[0]:
        tmpCollection = { ...tmpCollection, keyword: '' }
        break

      case INVOICE_FILTER_TAG_FIELDS[4]:
        tmpCollection = { ...tmpCollection, month_time: '' }
        break
      case INVOICE_FILTER_TAG_FIELDS[5]:
        tmpCollection = { ...tmpCollection, payment_status: '' }
        break
      case INVOICE_FILTER_TAG_FIELDS[6]:
        tmpCollection = { ...tmpCollection, payment_method: '' }
        break

      case INVOICE_FILTER_TAG_FIELDS[2]:
        tmpCollection = { ...tmpCollection, principal_id: '' }
        break

      case INVOICE_FILTER_TAG_FIELDS[3]:
        tmpCollection = { ...tmpCollection, user_id: '' }
        break

      default:
        break
    }

    const collection = { ...queries, ...tmpCollection }

    fetchInvoiceByTagDelete(collection, { forceLoading: true })
  }

  const filterTagDeleteAll = isSoft => {
    INVOICE_FILTER_TAG_FIELDS.forEach(item =>
      pageDispatch({
        type: invoiceActions.TAG_FILTER_DELETE,
        payload: { type: item },
      }),
    )

    pageDispatch({
      type: invoiceActions.FILTER_DATE_TIME_TRIGGER_UPDATE,
      payload: {
        trigger: dateTimeTrigger === null ? true : !dateTimeTrigger,
      },
    })

    if (isSoft) return

    const collection = {
      ...queries,
      date_type: 'created',
      start_date: '',
      end_date: '',
      principal_id: '',
      user_id: '',
      tracking_code: '',
      payment_status: '',
      payment_method: '',
      month_time:''
    }

    fetchInvoiceByFilter(collection, { forceLoading: true })
  }

  return {
    dateTime: {
      activeValue: dateTimeActiveValue,
      defaultValue: dateTimeDefaultValue,
      disabledDate: afterToday(),
      triggerDefault: dateTimeTrigger,
      start: filter.dateTime.start,
      end: filter.dateTime.end,
      value: dateTimeValue,
      onChange: handleDateTimeChange,
    },
    invoiceInfo: {
      value: invoiceInfoValue,
      activeValue: invoiceInfoActiveValue,
      onChange: handleInvoiceInfoChange,
    },
    status: {
      value: statusValue,
      activeValue: statusActiveValue,
      onChange: handleStatusChange,
    },
    invoiceType: {
      value: invoiceTypeValue,
      activeValue: invoiceTypeActiveValue,
      onChange: handleInvoiceTypeChange,
    },
    monthTime: {
      value: monthTimeValue,
      list: generatePaymentPeriods(),
      activeValue: monthTimeActiveValue,
      onChange: handleMonthTimeChange,
    },
    principal: {
      activeValue: principalActiveValue,
      keyword: principalKeyword,
      list: principalList,
      value: principalValue,
      onChange: handlePrincipalChange,
      onKeywordChange: handlePrincipalKeywordChange,
    },
    teacher: {
      activeValue: teacherActiveValue,
      keyword: teacherKeyword,
      list: teacherList,
      listOrigin: teacherListOrigin,
      value: teacherValue,
      onChange: handleEmployeeChange,
      onKeywordChange: handleEmployeeKeywordChange,
    },
    canSubmitOtherFilter,
    queries,
    functions: {
      hasFilter: () => [
        JSON.stringify(dateTimeActiveValue?.value) !==
        JSON.stringify(invoiceInitialState.filter.dateTime.activeValue?.value),
        !!principalActiveValue?.name,
        !!teacherActiveValue?.name,
        !!statusActiveValue?.name,
        !!invoiceTypeActiveValue?.name,
        !!monthTimeActiveValue,
        !!invoiceInfoActiveValue,
      ].includes(true),
      applyInvoiceOtherFilter,
      refresh: () =>
        fetchInvoiceByFilter(
          {
            ...queries,
            start: table.pagination.active * table.pagination.amount || 0,
          },
          { activePage: table.pagination.active, forceLoading: true },
        ),
      fetchUpdateData: () =>
        fetchInvoiceByFilter(
          {
            ...queries,
            start: table.pagination.active * table.pagination.amount,
          },
          { activePage: table.pagination.active, notClearDetail: true },
        ),
      filterTagDelete,
      filterTagDeleteAll,
    },
  }
}

export default useInvoiceFilterForm
